import React, { useEffect, useState, useMemo } from 'react';
import { WebsiteRoutes } from 'website/routes';
import { MainLayout } from 'website/components/Layout/components/MainLayout';
import { paths, ROOT_PATHS } from './paths';
import { useLocation, useParams } from 'react-router-dom';
import { PublicProfileRoutes } from 'routes';
import { LocaleGuard, LocaleRedirect } from './LocaleGuard';

function WebsiteWrapper({websiteRoutes = true}) {
  const location = useLocation();
  const { lang } = useParams();
  const [isPricing, setIsPricing] = useState(false);
  const initialVersion = useMemo(() => {
    const path = lang ? location.pathname.replace(new RegExp(`^/${lang}`), '') : location.pathname;

    if (path.endsWith('/pricing')) {
      setIsPricing(true);
    } else {
      setIsPricing(false);
    }

    if (location.state && location.state.websiteContext) {
      return location.state.websiteContext;
    }

    if (path.startsWith(`${ROOT_PATHS.WEBSITE}/buyers`)) {
      return 'buyers';
    }
    return 'suppliers';
  }, [location, lang]);

  const [websiteContext, setWebsiteContext] = useState(initialVersion);

  useEffect(() => {
    setWebsiteContext(initialVersion);
  }, [initialVersion]);
  
  if (websiteRoutes) {
     return (
      <MainLayout websiteContext={websiteContext} isPricing={isPricing}><WebsiteRoutes /></MainLayout>
    );
  }

  return (
    <MainLayout websiteContext={websiteContext} isPricing={isPricing}><PublicProfileRoutes /></MainLayout>
  );
}

export const websiteRoutes = [
  {
    path: `${ROOT_PATHS.WEBSITE}/*`,
    element: <LocaleRedirect />,
  },
  {
    path: `/:lang${ROOT_PATHS.WEBSITE}/*`,
    element: <LocaleGuard><WebsiteWrapper /></LocaleGuard>,
  },
  {
    path: `${ROOT_PATHS.COMPANY_PUBLIC_PROFILE}`,
    element: <LocaleRedirect />,
  },
  {
    path: `${ROOT_PATHS.LOCALIZED_COMPANY_PUBLIC_PROFILE}`,
    element: <LocaleGuard><WebsiteWrapper websiteRoutes={false} /></LocaleGuard>,
  }
];